// @ts-nocheck
import React from 'react';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import SignaturePad from 'react-signature-canvas';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  SecondaryButton,
  PrimaryButton,
} from 'components/__v2__/Button/ReusableButton';
import { Clear } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { useClientStyles } from '../../../../Styles';

const SignatureCanvas = ({
  sigCanvas,
  clear,
  saveSignature,
  setIsDialogOpen,
  isSignatureLoading,
}) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const classes = useClientStyles();

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <Typography>Signature</Typography>
        <IconButton
          onClick={() => {
            setIsDialogOpen(false);
          }}
        >
          <Clear />
        </IconButton>
      </Box>
      <Box className={classes.signCard}>
        <SignaturePad
          ref={sigCanvas}
          canvasProps={{
            className: 'signatureCanvas',
            width: isMobile ? 'auto' : 550,
            height: isMobile ? 300 : 200,
          }}
        />
      </Box>
      <Box
        mt={1}
        height={35}
        display="flex"
        justifyContent="right"
        style={{ gap: '8px' }}
      >
        <SecondaryButton variant="outlined" onClick={clear}>
          Clear
        </SecondaryButton>
        <PrimaryButton
          variant="contained"
          onClick={saveSignature}
          disabled={isSignatureLoading}
          endIcon={isSignatureLoading && <CircularProgress size={20} />}
        >
          Sign
        </PrimaryButton>
      </Box>
    </>
  );
};

export default SignatureCanvas;

SignatureCanvas.propTypes = {
  sigCanvas: PropTypes.object.isRequired,
  clear: PropTypes.func.isRequired,
  saveSignature: PropTypes.func.isRequired,
  setIsDialogOpen: PropTypes.func.isRequired,
  isSignatureLoading: PropTypes.bool.isRequired,
};
